import React from 'react';
import { connect } from 'react-redux';
import {Tabs} from 'antd';
import Iframe from 'yxyweb/common/components/portal/Iframe';
import uuid from 'uuid';
const TabPane = Tabs.TabPane;

// 业务权限控制
class BusinessJurisdiction extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      dataSource:[],
      index:0
    }
  }
  componentWillMount() {}
  componentDidMount(){
    let _this = this;
    const proxy = cb.rest.DynamicProxy.create({ getCommon: { url: '/menuConfig/bill/getBizdata', method: 'POST' } });
    proxy.getCommon({
        "fullname": "aa.menutab.MenutabConfig",
        "data": "AABS0341",
        "url":_this.props.data.url
    },(err, result) => {
      if (result)
        _this.setState({ dataSource: result });
    });
  }
  handleChange=(activeKey)=>{
    let {dataSource,index} = this.state;
    let _index=0;
    dataSource.length && dataSource.forEach((v,index)=>{
      if(v.host===activeKey){
        _index = index
      }
    })
    this.setState({index:_index})
  }
  componentWillUnmount() {}
  componentWillReceiveProps(nextProps) {}
  render() {
    let { width, height ,data} = this.props;
    let {dataSource,index} = this.state;
    cb.cache.set('businessJurisdiction'+ index,{mode:data.mode,id:data.url,readOnly:data.readOnly})
    return (
      <Tabs className='tab-list' type="card" animated={false} key={"AABS0204"} onChange={(key)=>this.handleChange(key)}>
        {
          dataSource.length ? dataSource.map((v,index)=>{
           return(  
              <TabPane tab={v.title} key={v.host}>
                <Iframe index={'AABS0204'} url={v.url+'?yxyToken='+cb.rest.AppContext.token+'&random=businessJurisdiction'+index} width={width} height={height-52} />
              </TabPane>
             )
          }) : <TabPane tab={'没有返回数据'}>没有返回数据</TabPane>
      }
      </Tabs>
    )
  }
};


function mapStateToProps(state) {
    return {
        // account:state.user.toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        // accountactions: bindActionCreators(accountactions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessJurisdiction);


// WEBPACK FOOTER //
// ./src/common/components/BusinessJurisdiction/BusinessJurisdiction.jsx